module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//green_3.png?v=816570d4";